import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router-dom';

const MemberDropdownPortal = ({ open, anchorRect, onClose }) => {
  useEffect(() => {
    if (!open) return;
    const handleClick = (e) => {
      if (e.target.closest('.member-dropdown-portal')) return;
      onClose();
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open, onClose]);

  if (!open || !anchorRect) return null;

  const style = {
    position: 'fixed',
    top: anchorRect.bottom + 4,
    left: anchorRect.left,
    minWidth: anchorRect.width,
    zIndex: 99999,
    background: '#fff',
    borderRadius: 12,
    boxShadow: '0 2px 16px rgba(0,0,0,0.12)',
    border: '1px solid #e5e7eb',
    padding: 0,
  };

  return ReactDOM.createPortal(
    <div className="member-dropdown-portal" style={style}>
      <Link
        to="/add-employee?role=internee"
        className="flex items-center gap-3 px-4 py-3 border-l-4 border-blue-500 hover:bg-blue-50 hover:text-blue-700 rounded-t-xl transition font-medium text-sm group"
        onClick={onClose}
        style={{ textDecoration: 'none' }}
      >
        <span className="flex items-center justify-center w-10 h-10 bg-blue-100 rounded-full text-blue-600 text-xl group-hover:bg-blue-200 transition">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M5.121 17.804A13.937 13.937 0 0112 15c2.5 0 4.847.655 6.879 1.804M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
        </span>
        <span className="flex flex-col items-start">
          <span className="font-bold text-base">Add Internee</span>
          <span className="text-xs text-gray-500">Temporary/trainee member</span>
        </span>
      </Link>
      <Link
        to="/add-employee?role=employee"
        className="flex items-center gap-3 px-4 py-3 border-l-4 border-green-500 hover:bg-green-50 hover:text-green-700 rounded-b-xl transition font-medium text-sm group"
        onClick={onClose}
        style={{ textDecoration: 'none' }}
      >
        <span className="flex items-center justify-center w-10 h-10 bg-green-100 rounded-full text-green-600 text-xl group-hover:bg-green-200 transition">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
        </span>
        <span className="flex flex-col items-start">
          <span className="font-bold text-base">Add Employee</span>
          <span className="text-xs text-gray-500">Regular staff member</span>
        </span>
      </Link>
    </div>,
    document.body
  );
};

export default MemberDropdownPortal; 